<template>
    <Table
        :cursorPointer="false"
        :isBorder="true"
        class="w-full mt-2.5"
    >
        <template #thead>
            <tr>
                <td class="px-4 py-2">
                    授權人(即持卡人)/身分證統一證號
                </td>
                <td class="px-4 py-2  w-[15rem]">
                    信用卡卡號
                </td>
                <td class="px-4 py-2  w-1/4">
                    有效月年
                </td>
            </tr>
        </template>
        <template #tbody>
            <tr class="text-gray-900">
                <td class="px-4 pt-6 pb-3 break-all w-1/4 align-top">
                    <p>
                        <slot name="holder-id" /><br>
                        <slot name="holder-name" />
                    </p>
                </td>
                <td class=" px-4 pt-6 pb-3 align-top">
                    <slot name="input" />
                    <div class="mr-4">
                        發卡機構：{{ data?.cardBankName || '' }}
                    </div>
                    <div>(限VISA、MASTER、聯合信用卡、JCB及AE卡)</div>
                </td>
                <td class="px-4 pt-6 pb-3 break-all align-top">
                    <div class="flex flex-wrap">
                        <slot name="select" />
                    </div>
                </td>
            </tr>
        </template>
    </Table>
</template>

<script>
import Table from '@/components/table/TableBase.vue';

export default {
    components: {
        Table
    },
    props: {
        data: {
            type: Object,
            default: () => { }
        }
    },
};
</script>
